<template>
    <diV>
        <!-----ฟอร์มรายการชำระหนี้---->
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">รายการจ่ายเงิน-จ่ายชำระหนี้</h2>
            <div class="row" style="margin-right: 10px">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                                class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่จ่ายเงิน
                        </label>
                        <div class="col-sm-8">
                            <date-picker
                                    v-model="form.receive_date"
                                    class="w-100"
                                    :disabled="disable_date"
                                    :format="changeFormat"
                                    :lang="lang"
                                    placeholder="วันที่จ่ายเงิน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                                class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสเจ้าหนี้
                        </label>
                        <div class="col-sm-8">
                            <multiselect
                                    @input="getRRVendor(form.vendor)"
                                    v-model="form.vendor"
                                    :options="optionVendor"
                                    :customLabel="vendorLabel"
                                    placeholder="เลือกรหัสเจ้าหนี้"
                                    :show-labels="false"
                                    track-by="name">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <!--<div class="form-group row">-->
                        <!--<label-->
                                <!--class="col-sm-4 col-form-label text-capitalize text-right">-->
                            <!--ใบจ่ายเงิน-->
                        <!--</label>-->
                        <!--<div class="col-sm-8">-->
                            <!--<input class="form-control"/>-->
                        <!--</div>-->
                    <!--</div>-->
                    <div class="form-group row" v-if="form.no">
                        <label
                                class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขที่ CS
                        </label>
                        <div class="col-sm-8">
                            <masked-input v-model="form.no"
                                          mask="CS111111111"
                                          placeholder="เลขที่ CS"
                                          class="form-control"
                                          type="text" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                                class="col-sm-4 col-form-label text-capitalize text-right">
                            ยอดจ่าย
                        </label>
                        <div class="col-sm-8">
                            <input type="number"
                                   v-model="calculatePrice"
                                   class="form-control" disabled/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                                class="col-sm-4 col-form-label text-capitalize text-right">ประเภทการชำระเงิน</label>
                        <div class="col-sm-6">
                            <template v-for="transaction in form.transactions">
                                <input type="checkbox" v-model="transaction.transaction_type_id"
                                       checked disabled/>
                                <span v-if="transaction.transaction_type">
                                    {{transaction.transaction_type.name}} : {{transaction.amount | currency}} บาท
                                    (วันที่ {{transaction.date ? transaction.date : form.receive_date | moment("DD/MM/YYYY")}})
                                </span>
                                <br>
                            </template>
                            <template v-if="form.fee_amount > 0">
                                <span>ค่าธรรมเนียม : {{form.fee_amount | currency}} บาท</span>
                            </template>
                            <template v-if="form.overpay > 0">
                                <span>จ่ายเงินเกิน : {{form.overpay | currency}} บาท</span>
                            </template>
                            <template v-if="form.arrears > 0">
                                <span>จ่ายเงินขาด : {{form.arrears | currency}} บาท</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <!--table-->
            <div class="col-sm-12 table-responsive" v-if="rr_vendor.length > 0">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">#บิล</th>
                        <th scope="col">วันที่บิล</th>
                        <th width="250px" scope="col">ยอดชำระ</th>
                        <th scope="col">คงค้าง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in rr_vendor">
                        <td>{{data.RR_number}}</td>
                        <td>{{data.date | moment("DD/MM/YYYY")}}</td>
                        <td align="center">
                            <!--จ่าย-->
                            <input v-model="data.price"
                                   type="number"
                                   class="form-control"/>
                        </td>
                        <td>{{data.outstanding_balance | currency}}</td>
                    </tr>
                    <tr style="background-color: white">
                        <td></td>
                        <td><b>รวม</b></td>
                        <td>{{calculatePrice | currency}}</td>
                        <td><b>{{totalPrice | currency}}</b></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-6"></div>
            <div class="col text-center mt-3">
                <button class="btn btn-success"
                        :disabled="!canSubmit"
                        @click="showBillingModal">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-outline-secondary" @click="goToRRPayoffList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
            <br/>
        </div>
        <!--b-modal payment-->
        <b-modal size="lg" hide-header hide-footer ref="billing_modal">
            <div>
                <payment-form-modal @submit="saveRRPayoff">
                </payment-form-modal>
            </div>
        </b-modal>
<!--        <pre class="alert-success">{{form}}</pre>-->
    </diV>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import { mapState } from "vuex"
    import Multiselect from "vue-multiselect";
    import PaymentFormModal from "./RRPayoffFormTransaction";
    import moment from "moment";
    import MaskedInput from 'vue-masked-input'

    export default {
        name: "payment-form1",
        props: {
            payment_type: { default: 1 },
            status : {default: null}
        },
        components: {
            PaymentFormModal,
            DatePicker,
            Multiselect,
            MaskedInput
        },
        created(){
            console.log("status" ,this.status);
            if(this.form.id){
                this.disable_date = true;
            }
            this.$store.dispatch("RRPayoff/getVendorFormPayoff");
            if(this.form.receive_date && !this.form.no && this.status == 1){
                this.generateCSNumber();
            }
        },
        data(){
            return{
                disable_date : false,
                items: [
                    {
                        text: "รายการตัดจ่าย",
                        to: { name: "rr-payoff-list" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        computed:{
            ...mapState({
                optionVendor:state=>{
                    return state.RRPayoff.vendor
                },
                form : state=>{
                    return state.RRPayoff.form
                },
                rr_vendor :state=>{
                    return state.RRPayoff.rr_vendor
                }
            }),
            totalPrice(){
                let total = this.rr_vendor.reduce((carry, detail) => {
                    if(detail.outstanding_balance){
                        this.form.amount = carry + parseFloat(detail.outstanding_balance)
                        return carry + parseFloat(detail.outstanding_balance);
                    }
                    else{
                        this.form.amount = carry;
                        return carry;
                    }
                }, 0);
                return parseFloat(total).toFixed(2);
            },
            calculatePrice(){
                let total = 0;
                return this.rr_vendor.reduce((carry, detail) => {
                    if(detail.price){
                        total = carry + parseFloat(detail.price)
                        return total = parseFloat(total.toFixed(2));
                    }
                    else{
                        total = carry;
                        return total = parseFloat(total.toFixed(2));
                    }
                }, 0);
            },
            canSubmit() {
                if(!this.form.receive_date || !this.form.vendor) {
                    return false
                }
                if(!this.validTotalAmount) {
                    return false
                }
                return true
            },
            validTotalAmount() {
                return this.calculatePrice <= this.totalPrice
            },
        },
        methods:{
            vendorLabel (option) {
                return `${option.vendor_id} - ${option.name}`
            },
            showBillingModal(){
                this.form.total_amount = this.calculatePrice;
                this.form.payment_type = this.payment_type;
                this.form.status = this.status;
                if(this.form.status == 2){
                    this.updateCsNumber();
                }else{
                    this.$refs.billing_modal.show();
                }
            },
            hideBillingModal(){
                this.$refs.billing_modal.hide();
            },
            getRRVendor(vendor){
                if(vendor){
                    let data = {
                      vendor_id: vendor.id
                    };
                    this.$store.dispatch("RRPayoff/getRRvendor",data)
                }
            },
            updateCsNumber(){
                let data= {
                    id : this.form.id,
                    no : this.form.no,
                }
                this.$store.dispatch("RRPayoff/updateCsNo",data).then(()=>{
                    this.goToRRPayoffList();
                }).catch(()=>{
                    alert('ไม่สามารถอัพเดตเลข CS ได้')
                })
            },
            saveRRPayoff(submitData){
                this.form.status = this.status;
                this.form.rr_payoff_other_details = [];
                this.form.payoff_purchase_details = [];
                this.form.rr_payoff_details = [];
                this.total_amount = this.calculatePrice;
                let rr_id = "";
                if(submitData){
                    this.rr_vendor.forEach(data=>{
                        if(data.price){
                            if(this.form.id){
                                rr_id = data.rr_id;
                            }
                            else{
                                rr_id = data.id;
                            }
                            let details = {
                                rr_id : rr_id,
                                price : parseFloat(data.price),
                                total : parseFloat(data.outstanding_balance),
                                date : moment(data.date).format("YYYY-MM-DD"),
                            };
                            this.form.rr_payoff_details.push(details);
                        }
                        else{
                            let details = {
                                rr_id : rr_id,
                                price : 0,
                                date : moment(data.date).format("YYYY-MM-DD"),
                                total : parseFloat(data.outstanding_balance),
                            };
                            this.form.rr_payoff_details.push(details);
                        }
                    });
                    this.$store.dispatch("RRPayoff/saveRRpayoff",this.form.id).then(res=>{
                        if(res){
                            this.goToRRPayoffList();
                        }else{
                            alert('มีการใช้รหัส CS นี้แล้ว กรุณาใส่รหัสใหม่')
                        }
                    });
                    this.hideBillingModal();
                }
                this.hideBillingModal();
            },
            goToRRPayoffList(){
                this.$router.push({
                    name : "rr-payoff-list"
                })
            },
            generateCSNumber(){
                let date = moment(this.form.receive_date).format('YYYY-MM-DD');
                this.$store.dispatch("RRPayoff/generateCS",date).then(res=>{
                    this.form.no = res;
                });
            }
        }
    }
</script>

<style scoped>
    thead{
        background-color: darkgrey;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
</style>
